import React from 'react';
// import { FaReact } from 'react-icons/fa';
import logo from '../images/agilehunter.png';

const Logo = () => {
  return (
    <div>
      {/* <FaReact /> */}
      <img src={logo} alt="Logo" height={64} />
    </div>
  );
};

export default Logo;
